const barChartReducer = (state: any, action: any) => {
    
    switch(action.type){
        case 'datapoints':
            return {
                ...state,
                data: [{
                    type: "bar",
                    dataPoints: action.nextDataPoints
                }]
            }
        case 'title':
            return {
                ...state,
                title: {
                    text: action.title
                }
            }
        default:
            return state;
    }
};

export { barChartReducer };